<template>
  <div class="carte-foodtruck" :class="[{ 'export-mode': isExport }, formatClass]">
    <!-- Artwork décoratif (print only) -->
    <img :src="require('@/assets/arts/lightstop.svg')" class="art art-topright print-only" alt="" aria-hidden="true">
    <img :src="require('@/assets/arts/boules.svg')" class="art art-bottomleft print-only" alt="" aria-hidden="true">
    <img :src="require('@/assets/arts/lightsbottom.svg')" class="art art-bottomright print-only" alt="" aria-hidden="true">

    <!-- Doodles décoratifs -->
    <img :src="require('@/assets/arts/star4.svg')" class="doodle doodle-star1" alt="" aria-hidden="true">
    <img :src="require('@/assets/arts/sparkle.svg')" class="doodle doodle-sparkle1" alt="" aria-hidden="true">
    <img :src="require('@/assets/arts/squiggle.svg')" class="doodle doodle-squiggle1" alt="" aria-hidden="true">

    <div class="carte-container">

      <!-- HEADER: Logo centré (print only) -->
      <div class="carte-header print-only">
        <img :src="require('@/assets/logotop.svg')" alt="Le Cabanon Annecy" class="logo">
      </div>

      <!-- HERO: Illustration foodtruck + horaires -->
      <div class="hero">
        <img :src="require('@/assets/arts/foodtruck.svg')" class="hero-illu" alt="Foodtruck Le Cabanon">
        <div class="hero-badge">12h à 22h</div>
      </div>

      <!-- MENU COMPLET (tous formats sauf camion) -->
      <div v-if="!contentReduit" class="menu-grid">

        <div class="menu-col">

          <section class="category color-teal">
            <h2>Les frites</h2>
            <div class="menu-item"><span class="item-name">Petite frite</span><span class="item-dots"></span><span class="item-price">4€</span></div>
            <div class="menu-item"><span class="item-name">Grande frite</span><span class="item-dots"></span><span class="item-price">7€</span></div>
          </section>

          <section class="category color-rose">
            <h2>Les smashburgers</h2>
            <div class="menu-item"><span class="item-name">Smashburger</span><span class="item-dots"></span><span class="item-price">8,5€</span></div>
            <div class="menu-item"><span class="item-name">Double smashburger</span><span class="item-dots"></span><span class="item-price">12€</span></div>
          </section>

          <section class="category color-amber">
            <h2>Les croques</h2>
            <div class="menu-item"><span class="item-name">Croque jambon</span><span class="item-dots"></span><span class="item-price">5,5€</span></div>
            <div class="menu-item"><span class="item-name">Croque veggie</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          </section>

        </div>

        <div class="menu-col">

          <section class="category color-teal">
            <h2>Autres</h2>
            <div class="menu-item"><span class="item-name">Tenders de poulet</span><span class="item-dots"></span><span class="item-price">8,5€</span></div>
            <div class="menu-item"><span class="item-name">Salade du moment</span><span class="item-dots"></span><span class="item-price">12€</span></div>
          </section>

          <section class="category color-rose">
            <h2>Le sucré</h2>
            <div class="menu-item"><span class="item-name">Gaufre de Liège</span><span class="item-dots"></span><span class="item-price">5€</span></div>
            <span class="item-desc">Nutella, confiture, sucre glace ou caramel beurre salé</span>
            <div class="menu-item glace-item"><span class="item-name">Glace</span><span class="item-dots"></span><span class="item-price">3€</span></div>
          </section>

        </div>

      </div>

      <!-- MENU RÉDUIT (camion uniquement) -->
      <div v-else class="menu-camion">
        <div class="camion-item color-rose">
          <span class="camion-name">Smashburger</span>
          <span class="camion-price">8,50€</span>
        </div>
        <div class="camion-item color-teal">
          <span class="camion-name">Frites</span>
          <span class="camion-price">4€</span>
        </div>
        <div class="camion-item color-amber">
          <span class="camion-name">Gaufres</span>
          <span class="camion-price">5€</span>
        </div>
        <div class="camion-item color-navy">
          <span class="camion-name">Glaces</span>
          <span class="camion-price">3€</span>
        </div>
      </div>

      <!-- BANDEAU FINAL -->
      <div class="footer-note">
        Bon appétit !<br><span class="footer-detail">Cuisine maison · Produits frais</span>
      </div>

      <!-- INSTAGRAM -->
      <div class="insta-container">
        <a href="https://www.instagram.com/lecabanon.annecy/" target="_blank" rel="noopener noreferrer" class="insta-link">
          <svg class="insta-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 157.1 25.8">
            <path fill="#0c0c0b" d="M21.2,6c0,.9-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5.7-1.5,1.5-1.5,1.5.7,1.5,1.5M12.8,17.1c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3,4.3,1.9,4.3,4.3-1.9,4.3-4.3,4.3M12.8,6.2c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-3,6.6-6.6-3-6.6-6.6-6.6M12.8,0C9.3,0,8.9,0,7.5,0c-1.4,0-2.3.3-3.1.6-.8.3-1.6.8-2.3,1.5-.7.7-1.2,1.4-1.5,2.3-.3.8-.5,1.7-.6,3.1C0,8.9,0,9.3,0,12.8s0,3.9,0,5.3c0,1.4.3,2.3.6,3.1.3.8.8,1.6,1.5,2.3.7.7,1.4,1.2,2.3,1.5.8.3,1.7.5,3.1.6,1.4,0,1.8,0,5.3,0s3.9,0,5.3,0c1.4,0,2.3-.3,3.1-.6.8-.3,1.6-.8,2.3-1.5.7-.7,1.2-1.4,1.5-2.3.3-.8.5-1.7.6-3.1,0-1.4,0-1.8,0-5.3s0-3.9,0-5.3c0-1.4-.3-2.3-.6-3.1-.3-.8-.8-1.6-1.5-2.3-.7-.7-1.4-1.2-2.3-1.5-.8-.3-1.7-.5-3.1-.6C16.8,0,16.3,0,12.8,0M12.8,2.3c3.4,0,3.8,0,5.2,0,1.3,0,1.9.3,2.4.4.6.2,1,.5,1.5,1,.4.4.7.9,1,1.5.2.5.4,1.1.4,2.4,0,1.4,0,1.8,0,5.2s0,3.8,0,5.2c0,1.3-.3,1.9-.4,2.4-.2.6-.5,1-1,1.5-.4.4-.9.7-1.5,1-.5.2-1.1.4-2.4.4-1.4,0-1.8,0-5.2,0s-3.8,0-5.2,0c-1.3,0-1.9-.3-2.4-.4-.6-.2-1-.5-1.5-1-.4-.4-.7-.9-1-1.5-.2-.5-.4-1.1-.4-2.4,0-1.4,0-1.8,0-5.2s0-3.8,0-5.2c0-1.3.3-1.9.4-2.4.2-.6.5-1,1-1.5.4-.4.9-.7,1.5-1,.5-.2,1.1-.4,2.4-.4,1.4,0,1.8,0,5.2,0"/>
            <text fill="#231f20" font-family="Montserrat, sans-serif" font-style="italic" font-size="9" x="29.1" y="11.2">Planning &amp; événements</text>
            <text fill="#231f20" font-family="Montserrat, sans-serif" font-weight="700" font-size="10" x="29.1" y="23.2">@lecabanon.annecy</text>
          </svg>
        </a>
      </div>

      <!-- BOUTONS -->
      <div class="pdf-container no-print">
        <router-link to="/" class="btn-back">← Retour à l'accueil</router-link>
        <a href="/carte-foodtruck.pdf" download="carte-foodtruck.pdf" class="btn-pdf">Télécharger la carte</a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CarteFoodtruck',
  computed: {
    isExport() {
      return this.$route.query.export === 'true' || this.$route.query.export === '1';
    },
    format() {
      return this.$route.query.format || 'a3';
    },
    formatClass() {
      return `format-${this.format}`;
    },
    contentReduit() {
      return this.format === 'camion';
    }
  },
  mounted() {
    if (this.isExport) {
      this.injectPageSize();
    }
    if (this.isExport && this.format !== 'a3') {
      this.$nextTick(() => this.fitPreview());
      window.addEventListener('resize', this.fitPreview);
      window.addEventListener('beforeprint', this.unsetScale);
      window.addEventListener('afterprint', this.fitPreview);
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.fitPreview);
    window.removeEventListener('beforeprint', this.unsetScale);
    window.removeEventListener('afterprint', this.fitPreview);
    this.unsetScale();
    this.removePageSize();
  },
  methods: {
    pageSizeFor(format) {
      const sizes = {
        'a3': 'A3 portrait',
        'camion': '230cm 178cm',
        'panneau-stop': '63.5cm 110cm',
        'ardoise-stop': '56.5cm 76cm',
        'ardoise-foodtruck': '70cm 204cm'
      };
      return sizes[format];
    },
    injectPageSize() {
      const size = this.pageSizeFor(this.format);
      if (!size) return;
      let style = document.getElementById('print-page-size');
      if (!style) {
        style = document.createElement('style');
        style.id = 'print-page-size';
        document.head.appendChild(style);
      }
      style.textContent = `@media print { @page { size: ${size}; margin: 0; } }`;
    },
    removePageSize() {
      const style = document.getElementById('print-page-size');
      if (style) style.remove();
    },
    fitPreview() {
      const root = this.$el;
      if (!root) return;
      root.style.zoom = '';
      const rootW = root.offsetWidth;
      const rootH = root.offsetHeight;
      const margin = 24;
      const scale = Math.min(
        (window.innerWidth - margin) / rootW,
        (window.innerHeight - margin) / rootH,
        1
      );
      if (scale < 1) {
        root.style.zoom = String(scale);
      }
    },
    unsetScale() {
      const root = this.$el;
      if (root) root.style.zoom = '';
    }
  }
}
</script>

<style scoped>
.carte-foodtruck {
  background-color: #eded87;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  padding: 40px 20px 60px;
}

/* Artworks décoratifs (print) */
.art {
  position: absolute;
  pointer-events: none;
  z-index: 0;
}
.art-topright {
  right: -80px;
  top: -120px;
  width: 280px;
}
.art-bottomright {
  right: -50px;
  bottom: -120px;
  width: 280px;
}
.art-bottomleft {
  left: -40px;
  bottom: -40px;
  width: 350px;
  transform: scaleX(-1);
}

/* Doodles décoratifs */
.doodle {
  position: absolute;
  pointer-events: none;
  z-index: 0;
}
.doodle-star1 {
  width: 55px;
  top: 80px;
  left: 8%;
  opacity: 0.5;
}
.doodle-sparkle1 {
  width: 60px;
  top: 50px;
  right: 12%;
  opacity: 0.45;
}
.doodle-squiggle1 {
  width: 100px;
  bottom: 70px;
  right: 8%;
  opacity: 0.3;
}

.carte-container {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* Print only */
.print-only {
  display: none;
}

/* Header: logo centré */
.carte-header {
  text-align: center;
  margin-bottom: 20px;
}
.logo {
  max-width: 450px;
  height: auto;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.15));
}

/* HERO */
.hero {
  text-align: center;
  position: relative;
  margin-bottom: 40px;
}
.hero-illu {
  display: block;
  max-width: 540px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
}
.hero-badge {
  display: inline-block;
  background-color: #1b3345;
  color: #eded87;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.6em;
  letter-spacing: 5px;
  padding: 12px 32px;
  border-radius: 16px;
  margin-top: -40px;
  position: relative;
  z-index: 3;
  transform: rotate(-2deg);
  box-shadow: 0 3px 10px rgba(27,51,69,0.25);
}

/* Grille menu : 2 colonnes manuelles */
.menu-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 60px;
}

.menu-col {
  display: flex;
  flex-direction: column;
}

/* Catégorie sans card */
.category {
  margin-bottom: 36px;
}

.category h2 {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.35em;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px dashed;
}

/* Couleurs par catégorie */
.color-teal h2 { color: #44bfb1; border-bottom-color: #44bfb1; }
.color-teal .item-price { color: #44bfb1; }
.color-teal .item-dots { border-bottom-color: #44bfb1; }

.color-rose h2 { color: #f387a2; border-bottom-color: #f387a2; }
.color-rose .item-price { color: #f387a2; }
.color-rose .item-dots { border-bottom-color: #f387a2; }

.color-amber h2 { color: #3c7397; border-bottom-color: #3c7397; }
.color-amber .item-price { color: #3c7397; }
.color-amber .item-dots { border-bottom-color: #3c7397; }

.color-navy h2 { color: #1b3345; border-bottom-color: #1b3345; }
.color-navy .item-price { color: #1b3345; }
.color-navy .item-dots { border-bottom-color: #1b3345; }

/* Items menu */
.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
  font-size: 1em;
}

.menu-item .item-name {
  font-weight: 700;
  text-transform: capitalize;
  color: #1b3345;
}

.item-dots {
  flex-grow: 1;
  border-bottom: 2px dotted;
  margin: 0 8px;
  opacity: 0.5;
}

.item-price {
  font-weight: 800;
  white-space: nowrap;
}

.item-desc {
  display: block;
  font-size: 0.85em;
  font-style: italic;
  color: #555;
  margin-top: 6px;
  margin-bottom: 10px;
  line-height: 1.4;
}

/* Bandeau final */
.footer-note {
  text-align: center;
  color: #1b3345;
  font-family: 'Adventures Unlimited', cursive;
  font-size: 4em;
  font-weight: bold;
  letter-spacing: 2px;
  margin-top: 20px;
  line-height: 0.85;
}
.footer-detail {
  display: inline-block;
  margin-top: -8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 0.22em;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #1b3345;
}

/* Instagram */
.insta-container {
  text-align: center;
  margin-top: 20px;
}
.insta-logo {
  width: 160px;
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
  transition: transform 0.2s ease;
}
.insta-logo:hover {
  transform: scale(1.05);
}

/* Boutons */
.pdf-container {
  text-align: center;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}
.btn-pdf,
.btn-back {
  display: inline-block;
  background-color: #1b3345;
  color: #eded87 !important;
  border: none;
  border-radius: 14px;
  padding: 12px 30px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1em;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-decoration: none !important;
}
.btn-back {
  background-color: transparent;
  color: #1b3345 !important;
  border: 2px solid #1b3345;
}
.btn-pdf:hover {
  background-color: #2a4d66;
}
.btn-back:hover {
  background-color: #1b3345;
  color: #eded87 !important;
}

/* Menu camion (réduit, paysage) */
.menu-camion {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin: 30px 0;
}
.camion-item {
  text-align: center;
  padding: 20px 10px;
  border: 3px dashed;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.camion-name {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5em;
  font-weight: 700;
  text-transform: capitalize;
  line-height: 1.1;
  color: #1b3345;
}
.camion-price {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.8em;
  letter-spacing: 1px;
}
.color-rose.camion-item { border-color: #f387a2; }
.color-rose .camion-name, .color-rose .camion-price { color: #f387a2; }
.color-teal.camion-item { border-color: #44bfb1; }
.color-teal .camion-name, .color-teal .camion-price { color: #44bfb1; }
.color-amber.camion-item { border-color: #3c7397; }
.color-amber .camion-name, .color-amber .camion-price { color: #3c7397; }
.color-navy.camion-item { border-color: #1b3345; }
.color-navy .camion-name, .color-navy .camion-price { color: #1b3345; }

/* Mode export PDF */
.export-mode {
  width: 297mm;
  height: 420mm;
  max-height: 420mm;
  overflow: hidden;
  padding: 15mm 12mm;
  box-sizing: border-box;
}
.export-mode .print-only {
  display: block !important;
}
.export-mode .no-print {
  display: none !important;
}
.export-mode .carte-container {
  max-width: 100%;
}
.export-mode .art {
  display: block !important;
}
.export-mode .carte-header {
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}
.export-mode .logo {
  max-width: 380px;
}
.export-mode .hero {
  margin-top: -25px;
  position: relative;
  z-index: 2;
}
.export-mode .hero-illu {
  max-width: 460px;
}
.export-mode .hero-badge {
  font-size: 2.2em;
  letter-spacing: 6px;
  padding: 16px 40px;
  margin-top: -55px;
}
.export-mode .footer-note {
  font-size: 5.6em;
}
.export-mode .footer-detail {
  font-size: 0.15em;
  margin-top: -10px;
}
.export-mode .insta-logo {
  width: 180px;
}
.export-mode .insta-container {
  margin-top: 12px;
}
.export-mode .hero-badge,
.export-mode .footer-note,
.export-mode .hero-illu,
.export-mode .insta-logo,
.export-mode .logo {
  box-shadow: none !important;
  filter: none !important;
}

/* ============================================
   FORMAT CAMION FOODTRUCK 230×178 cm (paysage)
   Contenu réduit : 4 items
   ============================================ */
.export-mode.format-camion {
  width: 230cm;
  height: 178cm;
  max-height: 178cm;
  padding: 60mm 80mm;
}
.export-mode.format-camion .carte-container {
  max-width: none;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.export-mode.format-camion .logo {
  max-width: 700mm;
}
.export-mode.format-camion .carte-header {
  margin-bottom: 0;
}
.export-mode.format-camion .hero {
  margin-top: -30mm;
}
.export-mode.format-camion .hero-illu {
  max-width: 850mm;
}
.export-mode.format-camion .hero-badge {
  font-size: 150pt;
  letter-spacing: 24px;
  padding: 28mm 60mm;
  border-radius: 40mm;
  margin-top: -90mm;
}
.export-mode.format-camion .menu-camion {
  margin: 40mm 250mm 30mm;
  gap: 30mm;
  grid-template-columns: repeat(4, 1fr);
}
.export-mode.format-camion .camion-item {
  padding: 28mm 12mm;
  border-width: 8mm;
  border-radius: 30mm;
}
.export-mode.format-camion .camion-name {
  font-size: 130pt;
  margin-bottom: 12mm;
}
.export-mode.format-camion .camion-price {
  font-size: 220pt;
}
.export-mode.format-camion .footer-note {
  font-size: 380pt;
  margin-top: auto;
}
.export-mode.format-camion .footer-detail {
  font-size: 90pt;
  margin-top: 8mm;
  letter-spacing: 18mm;
}
.export-mode.format-camion .insta-container {
  display: none;
}
/* Décorations camion : illus qui dépassent légèrement des coins */
.export-mode.format-camion .art-topright {
  width: 700mm;
  right: -120mm;
  top: -90mm;
}
.export-mode.format-camion .art-bottomright {
  width: 420mm;
  right: -80mm;
  bottom: -60mm;
  top: auto;
}
.export-mode.format-camion .art-bottomleft {
  width: 480mm;
  left: -90mm;
  bottom: -70mm;
  top: auto;
}
.export-mode.format-camion .doodle-star1 {
  width: 180mm;
  top: 220mm;
  left: 50mm;
}
.export-mode.format-camion .doodle-sparkle1 {
  width: 200mm;
  top: 120mm;
  right: 22%;
}
.export-mode.format-camion .doodle-squiggle1 {
  display: none;
}

/* ============================================
   FORMAT PANNEAU STOP TROTTOIR 63,5×110 cm
   Contenu complet
   ============================================ */
.export-mode.format-panneau-stop {
  width: 63.5cm;
  height: 110cm;
  max-height: 110cm;
  padding: 45mm 50mm;
}
.export-mode.format-panneau-stop .carte-container {
  max-width: none;
}
.export-mode.format-panneau-stop .logo {
  max-width: 280mm;
}
.export-mode.format-panneau-stop .hero-illu {
  max-width: 280mm;
}
.export-mode.format-panneau-stop .hero {
  margin-top: 0;
  margin-bottom: 8mm;
}
.export-mode.format-panneau-stop .hero-badge {
  font-size: 50pt;
  letter-spacing: 10px;
  padding: 12mm 28mm;
  margin-top: -45mm;
}
.export-mode.format-panneau-stop .menu-grid {
  grid-template-columns: 1fr;
  gap: 0;
  margin-top: 12mm;
}
.export-mode.format-panneau-stop .category {
  margin-bottom: 8mm;
}
.export-mode.format-panneau-stop .category h2 {
  font-size: 56pt;
  letter-spacing: 7px;
  margin-bottom: 5mm;
  padding-bottom: 4mm;
}
.export-mode.format-panneau-stop .menu-item {
  font-size: 36pt;
  margin-bottom: 5mm;
}
.export-mode.format-panneau-stop .item-desc {
  font-size: 28pt;
}
.export-mode.format-panneau-stop .footer-note {
  font-size: 140pt;
  margin-top: 14mm;
}
.export-mode.format-panneau-stop .footer-detail {
  font-size: 30pt;
  margin-top: 2mm;
  letter-spacing: 7mm;
}
.export-mode.format-panneau-stop .insta-logo {
  width: 220mm;
}
.export-mode.format-panneau-stop .art-topright {
  width: 280mm;
  right: -70mm;
  top: -60mm;
}
.export-mode.format-panneau-stop .art-bottomleft {
  width: 320mm;
  left: -90mm;
  bottom: -70mm;
}
.export-mode.format-panneau-stop .art-bottomright {
  width: 300mm;
  right: -90mm;
  bottom: -60mm;
}

/* ============================================
   FORMAT ARDOISE STOP TROTTOIR 56,5×76 cm
   Contenu complet, layout compact 2 colonnes
   ============================================ */
.export-mode.format-ardoise-stop {
  width: 56.5cm;
  height: 76cm;
  max-height: 76cm;
  padding: 35mm 40mm;
}
.export-mode.format-ardoise-stop .carte-container {
  max-width: none;
}
.export-mode.format-ardoise-stop .logo {
  max-width: 220mm;
}
.export-mode.format-ardoise-stop .hero {
  margin-top: -5mm;
  margin-bottom: 8mm;
}
.export-mode.format-ardoise-stop .hero-illu {
  max-width: 220mm;
}
.export-mode.format-ardoise-stop .hero-badge {
  font-size: 30pt;
  letter-spacing: 8px;
  padding: 8mm 22mm;
  margin-top: -32mm;
}
.export-mode.format-ardoise-stop .menu-grid {
  grid-template-columns: 1fr 1fr;
  gap: 0 22mm;
  margin-top: 10mm;
}
.export-mode.format-ardoise-stop .category {
  margin-bottom: 10mm;
}
.export-mode.format-ardoise-stop .category h2 {
  font-size: 40pt;
  letter-spacing: 6px;
  margin-bottom: 6mm;
  padding-bottom: 4mm;
}
.export-mode.format-ardoise-stop .menu-item {
  font-size: 26pt;
  margin-bottom: 4mm;
}
.export-mode.format-ardoise-stop .item-desc {
  font-size: 22pt;
}
.export-mode.format-ardoise-stop .footer-note {
  font-size: 130pt;
  margin-top: 18mm;
}
.export-mode.format-ardoise-stop .footer-detail {
  font-size: 24pt;
  margin-top: 4mm;
  letter-spacing: 6mm;
}
.export-mode.format-ardoise-stop .insta-logo {
  width: 170mm;
}
.export-mode.format-ardoise-stop .art-topright {
  width: 240mm;
  right: -60mm;
  top: -55mm;
}
.export-mode.format-ardoise-stop .art-bottomleft {
  width: 280mm;
  left: -70mm;
  bottom: -55mm;
}
.export-mode.format-ardoise-stop .art-bottomright {
  width: 240mm;
  right: -80mm;
  bottom: -50mm;
}

/* ============================================
   FORMAT ARDOISE FOODTRUCK 70×204 cm (très étroit)
   Contenu complet, 1 colonne, espaces verticaux
   ============================================ */
.export-mode.format-ardoise-foodtruck {
  width: 70cm;
  height: 204cm;
  max-height: 204cm;
  padding: 70mm 60mm;
}
.export-mode.format-ardoise-foodtruck .carte-container {
  max-width: none;
}
.export-mode.format-ardoise-foodtruck .logo {
  max-width: 440mm;
}
.export-mode.format-ardoise-foodtruck .hero {
  margin-top: -15mm;
  margin-bottom: 60mm;
}
.export-mode.format-ardoise-foodtruck .hero-illu {
  max-width: 440mm;
}
.export-mode.format-ardoise-foodtruck .hero-badge {
  font-size: 80pt;
  letter-spacing: 14px;
  padding: 18mm 45mm;
  margin-top: -80mm;
}
.export-mode.format-ardoise-foodtruck .menu-grid {
  grid-template-columns: 1fr;
  gap: 0;
}
.export-mode.format-ardoise-foodtruck .category {
  margin-bottom: 32mm;
}
.export-mode.format-ardoise-foodtruck .category h2 {
  font-size: 90pt;
  letter-spacing: 12px;
  margin-bottom: 14mm;
  padding-bottom: 6mm;
}
.export-mode.format-ardoise-foodtruck .menu-item {
  font-size: 60pt;
  margin-bottom: 10mm;
}
.export-mode.format-ardoise-foodtruck .item-desc {
  font-size: 50pt;
  margin-top: 6mm;
}
.export-mode.format-ardoise-foodtruck .footer-note {
  font-size: 260pt;
  margin-top: 30mm;
}
.export-mode.format-ardoise-foodtruck .footer-detail {
  font-size: 50pt;
  margin-top: 4mm;
  letter-spacing: 6mm;
}
.export-mode.format-ardoise-foodtruck .insta-logo {
  width: 360mm;
}
.export-mode.format-ardoise-foodtruck .art-topright {
  width: 280mm;
  right: -90mm;
  top: -50mm;
}
.export-mode.format-ardoise-foodtruck .art-bottomleft {
  width: 380mm;
  left: -80mm;
  bottom: -60mm;
}
.export-mode.format-ardoise-foodtruck .art-bottomright {
  width: 280mm;
  right: -90mm;
  bottom: -50mm;
}
.export-mode.format-ardoise-foodtruck .doodle-star1 {
  width: 60mm;
  top: 5%;
  right: 8%;
  left: auto;
}
.export-mode.format-ardoise-foodtruck .doodle-sparkle1 {
  width: 70mm;
  top: 28%;
  right: 6%;
}
.export-mode.format-ardoise-foodtruck .doodle-squiggle1 {
  display: none;
}

/* Responsive */
@media (max-width: 768px) {
  .menu-grid {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .logo {
    max-width: 280px;
  }
  .hero-illu {
    max-width: 320px;
  }
  .hero-badge {
    font-size: 0.95em;
    letter-spacing: 3px;
    padding: 6px 18px;
  }
  .insta-logo {
    width: 100px;
  }
  .doodle-star1, .doodle-sparkle1 {
    display: none;
  }
  .footer-note {
    font-size: 1.8em;
  }
}

/* Print : règles génériques. Les dimensions viennent de .export-mode (en cm/mm),
   donc pas besoin d'override de width/height ici. Pour les formats hors A3,
   l'utilisateur sélectionne « Format de papier personnalisé » dans le dialogue Cmd+P. */
@media print {
  @page {
    margin: 0;
  }

  .no-print {
    display: none !important;
  }

  .print-only {
    display: block !important;
  }

  .carte-foodtruck.export-mode,
  .art {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Annule le zoom preview écran pour l'impression */
  .carte-foodtruck.export-mode {
    zoom: 1 !important;
  }

  .hero-badge,
  .footer-note,
  .hero-illu,
  .insta-logo,
  .logo {
    box-shadow: none !important;
    filter: none !important;
  }
}

</style>
